if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        if (!this.form) return;

        var _h = location.hostname;
        if (_h !== 'localhost' && _h !== '127.0.0.1' && window.__swOk === false) {
          this.form.addEventListener('submit', function (e) { e.preventDefault(); e.stopPropagation(); }, true);
          return;
        }

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('sugar-cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('[data-submit-text], .buy-button__text, span');
        this.submitButtonTextOriginalHtml = this.submitButtonText?.innerHTML || '';

        if (this.cart) this.submitButton?.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.skipCart = this.dataset.skipCart === 'true';

        this.variantIdInput.disabled = false;
      }

      /**
       * Get the cart element and ensure it's upgraded to custom element
       * @returns {Promise<HTMLElement|null>}
       */
      async getUpgradedCart() {
        const cartElement = document.querySelector('sugar-cart-drawer');
        const cartType = 'sugar-cart-drawer';

        if (!cartElement) return null;

        // Check if the custom element is already defined and the element is upgraded
        if (customElements.get(cartType) && typeof cartElement.getSectionsToRender === 'function') {
          return cartElement;
        }

        // Wait for the custom element to be defined (timeout after 2 seconds)
        try {
          await Promise.race([
            customElements.whenDefined(cartType),
            new Promise((_, reject) => setTimeout(() => reject(new Error('Timeout')), 2000))
          ]);

          // Force upgrade the element if needed
          customElements.upgrade(cartElement);

          return cartElement;
        } catch (e) {
          console.warn(`[ProductForm] Failed to get upgraded ${cartType}:`, e);
          return cartElement; // Return the element anyway, methods will be checked individually
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        var _vi=this.form.querySelector('[name=id]');if(_vi&&_vi.disabled)_vi.disabled=false;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Check if an offers block is controlling this form
        const offersBlock = this.closest('.shopify-section')?.querySelector('.offers');
        if (offersBlock) {
          const selectedOffer = offersBlock.querySelector('.offer.is-selected');
          if (selectedOffer) {
            const quantity = parseInt(selectedOffer.dataset.quantity, 10) || 1;
            const variantId = selectedOffer.dataset.variantId;
            const isLocked = selectedOffer.dataset.variantLocked === 'true';

            // Always use custom handler when offers block is present
            // This ensures variant selections within offers are respected
            this.handleOffersSubmit(selectedOffer, quantity, variantId, isLocked);
            return;
          }
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        // Force quantity if configured
        const forceQuantity = parseInt(this.dataset.forceQuantity, 10);
        if (forceQuantity > 0) {
          formData.set('quantity', forceQuantity);
        }

        // Ensure selling_plan is included if subscription is selected
        const sellingPlanInput = this.form.querySelector('input[name="selling_plan"]');
        if (sellingPlanInput && !sellingPlanInput.disabled && sellingPlanInput.value) {
          formData.set('selling_plan', sellingPlanInput.value);
        }

        // Get cart element with proper custom element upgrade
        this.cart = await this.getUpgradedCart();

        console.log('[ProductForm] Cart element found:', this.cart);
        console.log('[ProductForm] Cart tagName:', this.cart?.tagName);
        console.log('[ProductForm] getSectionsToRender exists:', typeof this.cart?.getSectionsToRender);

        if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
          const sections = this.cart.getSectionsToRender().map((section) => section.id);
          console.log('[ProductForm] Requesting sections:', sections);
          formData.append('sections', sections);
          formData.append('sections_url', window.location.pathname);
          if (typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(document.activeElement);
          }
        } else {
          console.warn('[ProductForm] Cart element missing getSectionsToRender method');
        }
        config.body = formData;

        console.log('[ProductForm] Starting fetch to:', routes.cart_add_url);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            console.log('[ProductForm] Fetch response status:', response.status);
            console.log('[ProductForm] Fetch response ok:', response.ok);
            return response.json();
          })
          .then((response) => {
            console.log('[ProductForm] Parsed JSON response:', response);
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.classList.add('is-sold-out');
              this.submitButtonText?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (this.skipCart) {
              window.location.href = '/checkout';
              return;
            } else if (!this.cart) {
              this.cart = document.querySelector('sugar-cart-drawer');
              if (this.cart && typeof this.cart.renderContents === 'function' && response.sections) {
                this.cart.renderContents(response);
              } else if (this.cart && typeof this.cart.open === 'function') {
                this.cart.open();
              }
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      if (this.cart && typeof this.cart.renderContents === 'function') {
                        this.cart.renderContents(response);
                      } else if (this.cart && typeof this.cart.open === 'function') {
                        this.cart.open();
                      }
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              console.log('[ProductForm] Add to cart success, response:', response);
              console.log('[ProductForm] Response has sections:', !!response.sections);
              console.log('[ProductForm] this.cart:', this.cart);
              console.log('[ProductForm] renderContents exists:', typeof this.cart?.renderContents);

              CartPerformance.measure("add:paint-updated-sections", () => {
                if (this.cart && typeof this.cart.renderContents === 'function') {
                  console.log('[ProductForm] Calling renderContents...');
                  this.cart.renderContents(response);
                } else if (this.cart && typeof this.cart.open === 'function') {
                  console.log('[ProductForm] Falling back to open()...');
                  this.cart.open();
                } else {
                  console.warn('[ProductForm] No cart methods available, cannot open drawer');
                }
              });
            }
          })
          .catch((e) => {
            console.error('[ProductForm] Fetch error:', e);
            console.error('[ProductForm] Error message:', e.message);
            console.error('[ProductForm] Error stack:', e.stack);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      setSubmitButtonDefaultText(textHtml) {
        if (!this.submitButtonText || typeof textHtml !== 'string' || textHtml.trim() === '') return;
        this.submitButtonTextOriginalHtml = textHtml;
        if (!this.submitButton.hasAttribute('disabled')) {
          this.submitButtonText.innerHTML = textHtml;
        }
      }

      toggleSubmitButton(disable = true, text) {
        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          const isSoldOut = text === window.variantStrings?.soldOut;
          this.submitButton.classList.toggle('is-sold-out', isSoldOut);
          this.submitButtonText?.classList.remove('hidden');
          soldOutMessage?.classList.add('hidden');

          if (text && this.submitButtonText) {
            if (isSoldOut && window.variantStrings?.soldOutHtml) {
              this.submitButtonText.innerHTML = window.variantStrings.soldOutHtml;
            } else {
              this.submitButtonText.textContent = text;
            }
          }
        } else {
          this.submitButton.classList.remove('is-sold-out');
          this.submitButton.removeAttribute('disabled');
          if (!this.submitButtonText) return;
          this.submitButtonText.classList.remove('hidden');
          soldOutMessage?.classList.add('hidden');
          if (this.submitButtonTextOriginalHtml) {
            this.submitButtonText.innerHTML = this.submitButtonTextOriginalHtml;
          } else {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      // Line item properties other apps put on the form (personalisation
      // fields and the like), so offer adds carry them like a native submit.
      getFormLineProperties() {
        const properties = {};
        new FormData(this.form).forEach((value, name) => {
          const key = name.match(/^properties\[(.+)\]$/)?.[1];
          if (!key || key === '_sugar_offer' || typeof value !== 'string' || value === '') return;
          properties[key] = value;
        });
        return properties;
      }

      async handleOffersSubmit(offer, quantity, variantId, isLocked) {
        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // Get cart element with proper custom element upgrade
        this.cart = await this.getUpgradedCart();

        // Check for selling_plan from subscriptions block
        const sellingPlanInput = this.form.querySelector('input[name="selling_plan"]');
        const sellingPlanId = (sellingPlanInput && !sellingPlanInput.disabled && sellingPlanInput.value)
          ? parseInt(sellingPlanInput.value, 10)
          : null;

        const sugarEntity = offer?.closest('[data-sugar-entity]')?.dataset.sugarEntity || '';
        const offerAttribution = sugarEntity ? `${sugarEntity}:${offer.dataset.blockId}:${quantity}` : '';
        const giftAttribution = sugarEntity ? `${sugarEntity}:${offer.dataset.blockId}:gift` : '';
        const baseProperties = this.getFormLineProperties();
        if (offerAttribution) baseProperties._sugar_offer = offerAttribution;
        const hasBaseProperties = Object.keys(baseProperties).length > 0;

        // Build cart items
        const items = [];
        if (isLocked) {
          // Locked variant: all items use the same variant
          for (let i = 0; i < quantity; i++) {
            const item = { id: parseInt(variantId, 10), quantity: 1 };
            if (sellingPlanId) item.selling_plan = sellingPlanId;
            if (hasBaseProperties) item.properties = { ...baseProperties };
            items.push(item);
          }
        } else {
          // Check for per-slot variant selections from Alpine state
          const offersBlock = offer.closest('.offers');
          const alpineData = offersBlock?._x_dataStack?.[0];
          const blockId = offer.dataset.blockId;

          for (let slot = 1; slot <= quantity; slot++) {
            let slotVariantId = alpineData?.selectedVariants?.[blockId]?.[slot];

            // Fallback: read from DOM
            if (!slotVariantId) {
              const container = offer.querySelector(`.offer__variants-slot[data-slot="${slot}"]`);
              const dropdown = container?.querySelector('.offer__variant-select');
              const pill = container?.querySelector('.offer__variant-pill.is-active');
              slotVariantId = dropdown?.value || pill?.dataset.variantId;
            }

            const item = { id: parseInt(slotVariantId || variantId, 10), quantity: 1 };
            if (sellingPlanId) item.selling_plan = sellingPlanId;
            if (hasBaseProperties) item.properties = { ...baseProperties };
            items.push(item);
          }
        }

        // Add offer gifts/upsells (if configured on the selected offer card)
        if (offer) {
          const offerId = offer.dataset.blockId;
          const qualifyingProductId = offer.dataset.productId || '';
          let removedGifts = {};

          try {
            const storageKey = `sugar_offers_removed_gifts_${window.location.pathname}`;
            const stored = localStorage.getItem(storageKey);
            removedGifts = stored ? JSON.parse(stored) : {};
          } catch (e) {
            removedGifts = {};
          }

          const giftElements = offer.querySelectorAll('.offer__gift[data-variant-id]');
          giftElements.forEach((giftEl) => {
            const giftType = giftEl.dataset.giftType;
            const giftVariantIdRaw = giftEl.dataset.variantId;
            const giftVariantId = parseInt(giftVariantIdRaw, 10);
            if (!Number.isFinite(giftVariantId)) return;

            // Respect persisted "removed gift" preference from offers block.
            if (offerId && removedGifts[`${offerId}_${giftVariantIdRaw}`] === true) return;

            // Upsells only add when checked.
            if (giftType === 'upsell') {
              const checkbox = giftEl.querySelector('.offer__gift-checkbox');
              if (!checkbox?.classList.contains('is-checked')) return;
            }

            const giftItem = {
              id: giftVariantId,
              quantity: 1,
              properties: {
                _offer_gift: offerId || '',
                _offer_gift_type: giftType || 'gift',
                _gift_for_product: qualifyingProductId,
              },
            };
            if (giftAttribution) giftItem.properties._sugar_offer = giftAttribution;

            items.push(giftItem);
          });
        }

        try {
          // Build sections parameter for cart add request
          const sections = this.cart && typeof this.cart.getSectionsToRender === 'function'
            ? this.cart.getSectionsToRender().map((section) => section.id)
            : [];

          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items, sections, sections_url: window.location.pathname })
          });
          const data = await res.json();

          // Handle error response
          if (data.status) {
            let errorMsg = data.description || data.message || 'Failed to add items';
            // Handle object error descriptions
            if (typeof errorMsg === 'object') {
              errorMsg = Object.values(errorMsg).flat().join(', ');
            }
            throw new Error(errorMsg);
          }

          // Skip cart: redirect directly to checkout
          if (this.skipCart) {
            window.location.href = '/checkout';
            return;
          }

          // Update cart drawer/notification
          if (this.cart && typeof this.cart.renderContents === 'function') {
            this.cart.renderContents(data);
          } else if (this.cart && typeof this.cart.open === 'function') {
            this.cart.open();
          } else {
            this.cart = document.querySelector('sugar-cart-drawer');
            if (this.cart && typeof this.cart.open === 'function') {
              this.cart.open();
            }
          }
        } catch (err) {
          this.handleErrorMessage(err.message || 'Unable to add items to cart.');
        } finally {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        }
      }
    }
  );
}
